import React from "react";
import { Check } from "lucide-react";

const items = [
  { label: "5 professional short-form videos", retail: "$500" },
  { label: "5 branded social images", retail: "$250" },
  { label: "Custom styled to your brand", retail: "$150" },
  { label: "Delivered in 72–96 hours", retail: "$100" },
  { label: "Google Drive folder, no fluff", retail: "$50" },
  { label: "Zero calls, zero meetings", retail: "Priceless" },
];

export const ValueStack = () => {
  return (
    <section className="py-20 md:py-28" data-testid="value-stack-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center">
          <span className="pill" data-testid="value-pill">What You Actually Get</span>
          <h2 className="mt-5 font-display font-bold text-white text-4xl sm:text-5xl tracking-tighter">
            Worth over <span className="text-[#3B9EFF]">$1,050</span>. <br className="hidden md:block" /> You pay $99.99.
          </h2>
        </div>
        <div className="mt-12 snap-card max-w-3xl mx-auto relative">
          <div className="corner-bracket tl" />
          <div className="corner-bracket tr" />
          <div className="corner-bracket bl" />
          <div className="corner-bracket br" />
          <ul className="divide-y divide-[#3B9EFF]/10">
            {items.map((it, i) => (
              <li key={i} className="flex items-center justify-between py-4" data-testid={`value-row-${i}`}>
                <div className="flex items-center gap-3">
                  <span className="w-7 h-7 rounded-full bg-[#3B9EFF]/15 border border-[#3B9EFF]/40 flex items-center justify-center text-[#3B9EFF]">
                    <Check size={14} />
                  </span>
                  <span className="text-white font-medium">{it.label}</span>
                </div>
                <span className="font-display font-bold text-[#A0AABF] line-through">{it.retail}</span>
              </li>
            ))}
          </ul>
          <div className="mt-8 pt-6 border-t border-[#3B9EFF]/20 flex flex-col md:flex-row items-center justify-between gap-4">
            <div>
              <p className="text-[#A0AABF] text-sm">Total real value</p>
              <p className="font-display text-2xl font-bold line-through text-[#A0AABF]">$1,050+</p>
            </div>
            <div className="text-center md:text-right">
              <p className="font-accent text-xs text-[#3B9EFF]">YOUR PRICE TODAY</p>
              <p className="font-display text-5xl font-black text-[#3B9EFF] leading-none">$99.99</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValueStack;
